// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccessoController from "./accesso_controller"
application.register("accesso", AccessoController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AiutoFaseController from "./aiuto_fase_controller"
application.register("aiuto-fase", AiutoFaseController)

import AnalysisPollController from "./analysis_poll_controller"
application.register("analysis-poll", AnalysisPollController)

import AnalyzeModalController from "./analyze_modal_controller"
application.register("analyze-modal", AnalyzeModalController)

import AzioneLicenzaController from "./azione_licenza_controller"
application.register("azione-licenza", AzioneLicenzaController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DettaglioOrgController from "./dettaglio_org_controller"
application.register("dettaglio-org", DettaglioOrgController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import DominiController from "./domini_controller"
application.register("domini", DominiController)

import GrantFormController from "./grant_form_controller"
application.register("grant-form", GrantFormController)

import GuidaBenvenutoController from "./guida_benvenuto_controller"
application.register("guida-benvenuto", GuidaBenvenutoController)

import FormModificatoController from "./form_modificato_controller"
application.register("form-modificato", FormModificatoController)

import InvioAlCambioController from "./invio_al_cambio_controller"
application.register("invio-al-cambio", InvioAlCambioController)

import InvitoController from "./invito_controller"
application.register("invito", InvitoController)

import ModalitaController from "./modalita_controller"
application.register("modalita", ModalitaController)

import OrgRigaController from "./org_riga_controller"
application.register("org-riga", OrgRigaController)

import OrgSwitcherController from "./org_switcher_controller"
application.register("org-switcher", OrgSwitcherController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ConteggiController from "./conteggi_controller"
application.register("conteggi", ConteggiController)

import ConservaStatoController from "./conserva_stato_controller"
application.register("conserva-stato", ConservaStatoController)

import PromptController from "./prompt_controller"
application.register("prompt", PromptController)

import AnnullaMovimentoController from "./annulla_movimento_controller"
application.register("annulla-movimento", AnnullaMovimentoController)

import ApriPassoController from "./apri_passo_controller"
application.register("apri-passo", ApriPassoController)

import NuovaDemoController from "./nuova_demo_controller"
application.register("nuova-demo", NuovaDemoController)

import ReimpostaController from "./reimposta_controller"
application.register("reimposta", ReimpostaController)

import RichiestaPianoController from "./richiesta_piano_controller"
application.register("richiesta-piano", RichiestaPianoController)

import RiquadroController from "./riquadro_controller"
application.register("riquadro", RiquadroController)

import ScaricaController from "./scarica_controller"
application.register("scarica", ScaricaController)

import ScorriInAltoController from "./scorri_in_alto_controller"
application.register("scorri-in-alto", ScorriInAltoController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SenzaInvioController from "./senza_invio_controller"
application.register("senza-invio", SenzaInvioController)

import SicurezzaController from "./sicurezza_controller"
application.register("sicurezza", SicurezzaController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TrovaController from "./trova_controller"
application.register("trova", TrovaController)

import TrovaRisultatiController from "./trova_risultati_controller"
application.register("trova-risultati", TrovaRisultatiController)

import IngestBandoController from "./ingest_bando_controller"
application.register("ingest-bando", IngestBandoController)

import FiltriOpportunitaController from "./filtri_opportunita_controller"
application.register("filtri-opportunita", FiltriOpportunitaController)

import OpportunitaController from "./opportunita_controller"
application.register("opportunita", OpportunitaController)

import TypedConfirmController from "./typed_confirm_controller"
application.register("typed-confirm", TypedConfirmController)

import ComunePickerController from "./comune_picker_controller"
application.register("comune-picker", ComunePickerController)

import ElencoRemotoController from "./elenco_remoto_controller"
application.register("elenco-remoto", ElencoRemotoController)

import ImpresaDaPivaController from "./impresa_da_piva_controller"
application.register("impresa-da-piva", ImpresaDaPivaController)

import ImpresaFormController from "./impresa_form_controller"
application.register("impresa-form", ImpresaFormController)

import ForzaAziendaleController from "./forza_aziendale_controller"
application.register("forza-aziendale", ForzaAziendaleController)

import MaggiorazioniController from "./maggiorazioni_controller"
application.register("maggiorazioni", MaggiorazioniController)

import FiltriCatalogoController from "./filtri_catalogo_controller"
application.register("filtri-catalogo", FiltriCatalogoController)

import MostraSeController from "./mostra_se_controller"
application.register("mostra-se", MostraSeController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import RigheController from "./righe_controller"
application.register("righe", RigheController)

import TerritorioEditorController from "./territorio_editor_controller"
application.register("territorio-editor", TerritorioEditorController)

import FollowGrantController from "./follow_grant_controller"
application.register("follow-grant", FollowGrantController)

import InvioUnicoController from "./invio_unico_controller"
application.register("invio-unico", InvioUnicoController)

import ScorriInVistaController from "./scorri_in_vista_controller"
application.register("scorri-in-vista", ScorriInVistaController)

import InfoTipController from "./info_tip_controller"
application.register("info-tip", InfoTipController)

import ConservaCatalogoController from "./conserva_catalogo_controller"
application.register("conserva-catalogo", ConservaCatalogoController)

import CaricaModuliController from "./carica_moduli_controller"
application.register("carica-moduli", CaricaModuliController)

import IngestController from "./ingest_controller"
application.register("ingest", IngestController)

import PassoController from "./passo_controller"
application.register("passo", PassoController)

import VaiAlPassoController from "./vai_al_passo_controller"
application.register("vai-al-passo", VaiAlPassoController)

import ControlloRagioniController from "./controllo_ragioni_controller"
application.register("controllo-ragioni", ControlloRagioniController)

import OccupatoController from "./occupato_controller"
application.register("occupato", OccupatoController)

import PagineLinkController from "./pagine_link_controller"
application.register("pagine-link", PagineLinkController)

import ConservaModificheController from "./conserva_modifiche_controller"
application.register("conserva-modifiche", ConservaModificheController)

import ClassiDocumentiController from "./classi_documenti_controller"
application.register("classi-documenti", ClassiDocumentiController)

import OrdineAttiController from "./ordine_atti_controller"
application.register("ordine-atti", OrdineAttiController)

import NomeFileController from "./nome_file_controller"
application.register("nome-file", NomeFileController)

import EfficaciaAttoController from "./efficacia_atto_controller"
application.register("efficacia-atto", EfficaciaAttoController)

import InventarioZipController from "./inventario_zip_controller"
application.register("inventario-zip", InventarioZipController)

import DatiPassoController from "./dati_passo_controller"
application.register("dati-passo", DatiPassoController)

import MaggiorazioneCoperturaController from "./maggiorazione_copertura_controller"
application.register("maggiorazione-copertura", MaggiorazioneCoperturaController)

import QuotaTerritorialeController from "./quota_territoriale_controller"
application.register("quota-territoriale", QuotaTerritorialeController)

import CampiRigheController from "./campi_righe_controller"
application.register("campi-righe", CampiRigheController)

import ElencoOrdinatoController from "./elenco_ordinato_controller"
application.register("elenco-ordinato", ElencoOrdinatoController)

import ProvaSalController from "./prova_sal_controller"
application.register("prova-sal", ProvaSalController)

import ProvaVersioniModuliController from "./prova_versioni_moduli_controller"
application.register("prova-versioni-moduli", ProvaVersioniModuliController)

import ForfettarioController from "./forfettario_controller"
application.register("forfettario", ForfettarioController)

import ModuliCampiController from "./moduli_campi_controller"
application.register("moduli-campi", ModuliCampiController)
import ModuloController from "./modulo_controller"
application.register("modulo", ModuloController)

import FonteRigaController from "./fonte_riga_controller"
application.register("fonte-riga", FonteRigaController)

import ScaricaJsonController from "./scarica_json_controller"
application.register("scarica-json", ScaricaJsonController)

import SedeFieldsController from "./sede_fields_controller"
application.register("sede-fields", SedeFieldsController)

import VediTutteController from "./vedi_tutte_controller"
application.register("vedi-tutte", VediTutteController)

import PaginaProgettoController from "./pagina_progetto_controller"
application.register("pagina-progetto", PaginaProgettoController)

import RiepilogoController from "./riepilogo_controller"
application.register("riepilogo", RiepilogoController)

import SoloCoerentiController from "./solo_coerenti_controller"
application.register("solo-coerenti", SoloCoerentiController)

import IdeaProgettoController from "./idea_progetto_controller"
application.register("idea-progetto", IdeaProgettoController)

import TracciaController from "./traccia_controller"
application.register("traccia", TracciaController)

import IstruttoriaAiController from "./istruttoria_ai_controller"
application.register("istruttoria-ai", IstruttoriaAiController)

import RichiesteOpportunitaController from "./richieste_opportunita_controller"
application.register("richieste-opportunita", RichiesteOpportunitaController)

import VociEditorController from "./voci_editor_controller"
application.register("voci-editor", VociEditorController)

import StatoVoceController from "./stato_voce_controller"
application.register("stato-voce", StatoVoceController)

import BudgetController from "./budget_controller"
application.register("budget", BudgetController)

import DatoTecnicoController from "./dato_tecnico_controller"
application.register("dato-tecnico", DatoTecnicoController)

import WorthItController from "./worth_it_controller"
application.register("worth-it", WorthItController)

import DettagliApertiController from "./dettagli_aperti_controller"
application.register("dettagli-aperti", DettagliApertiController)

import AnalisiInfoController from "./analisi_info_controller"
application.register("analisi-info", AnalisiInfoController)

import ToggleBoxController from "./toggle_box_controller"
application.register("toggle-box", ToggleBoxController)

import CampoNaController from "./campo_na_controller"
application.register("campo-na", CampoNaController)

import PannelloAnalisiController from "./pannello_analisi_controller"
application.register("pannello-analisi", PannelloAnalisiController)

import AnteprimaBozzaController from "./anteprima_bozza_controller"
application.register("anteprima-bozza", AnteprimaBozzaController)

import VociAssistantController from "./voci_assistant_controller"
application.register("voci-assistant", VociAssistantController)

import ConfrontoBozzeController from "./confronto_bozze_controller"
application.register("confronto-bozze", ConfrontoBozzeController)

import RevisioneBozzaController from "./revisione_bozza_controller"
application.register("revisione-bozza", RevisioneBozzaController)

import ReadinessController from "./readiness_controller"
application.register("readiness", ReadinessController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import CaricaPagamentiController from "./carica_pagamenti_controller"
application.register("carica-pagamenti", CaricaPagamentiController)

import CollegamentiEditorController from "./collegamenti_editor_controller"
application.register("collegamenti-editor", CollegamentiEditorController)

import MetodoPagamentoController from "./metodo_pagamento_controller"
application.register("metodo-pagamento", MetodoPagamentoController)

import VisuraCameraleController from "./visura_camerale_controller"
application.register("visura-camerale", VisuraCameraleController)

import AskController from "./ask_controller"
application.register("ask", AskController)

import VersioniModuliController from "./versioni_moduli_controller"
application.register("versioni-moduli", VersioniModuliController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import LeadInvioController from "./lead_invio_controller"
application.register("lead-invio", LeadInvioController)

import LeadLetteController from "./lead_lette_controller"
application.register("lead-lette", LeadLetteController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import ContattiController from "./contatti_controller"
application.register("contatti", ContattiController)

import RicercaController from "./ricerca_controller"
application.register("ricerca", RicercaController)

import BackupPanelController from "./backup_panel_controller"
application.register("backup-panel", BackupPanelController)

import ConversionePanelController from "./conversione_panel_controller"
application.register("conversione-panel", ConversionePanelController)

import PreferenzeAvvisiController from "./preferenze_avvisi_controller"
application.register("preferenze-avvisi", PreferenzeAvvisiController)

import ElencoDettaglioController from "./elenco_dettaglio_controller"
application.register("elenco-dettaglio", ElencoDettaglioController)

import PreventivoController from "./preventivo_controller"
application.register("preventivo", PreventivoController)

import InvioRendicontazioneController from "./invio_rendicontazione_controller"
application.register("invio-rendicontazione", InvioRendicontazioneController)

import NonRichiestoController from "./non_richiesto_controller"
application.register("non-richiesto", NonRichiestoController)

import DatoEditorController from "./dato_editor_controller"
application.register("dato-editor", DatoEditorController)

import CaricaDecretoController from "./carica_decreto_controller"
application.register("carica-decreto", CaricaDecretoController)

import RigheEditorController from "./righe_editor_controller"
application.register("righe-editor", RigheEditorController)

import CapitolatiEditorController from "./capitolati_editor_controller"
application.register("capitolati-editor", CapitolatiEditorController)

import CampiRichiestiController from "./campi_richiesti_controller"
application.register("campi-richiesti", CampiRichiestiController)

import RigheEspandibiliController from "./righe_espandibili_controller"
application.register("righe-espandibili", RigheEspandibiliController)

import VaiSchedaController from "./vai_scheda_controller"
application.register("vai-scheda", VaiSchedaController)

import OperazioneController from "./operazione_controller"
application.register("operazione", OperazioneController)

import FattiSalController from "./fatti_sal_controller"
application.register("fatti-sal", FattiSalController)

import EventoFormController from "./evento_form_controller"
application.register("evento-form", EventoFormController)
